var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9137 8.75201V12.252C2.9137 14.002 3.7887 14.877 5.5387 14.877H6.78995C7.1137 14.877 7.43745 14.9733 7.71745 15.1395L10.2724 16.7408C12.4774 18.1233 14.2887 17.117 14.2887 14.5183V6.48576C14.2887 3.87826 12.4774 2.88076 10.2724 4.26326L7.71745 5.86451C7.43745 6.03076 7.1137 6.12701 6.78995 6.12701H5.5387C3.7887 6.12701 2.9137 7.00201 2.9137 8.75201Z",
    stroke: "#F82643",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9137 7C18.4712 9.07375 18.4712 11.9262 16.9137 14",
    stroke: "#F82643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.aef5d0497448b5e1b5b2206621cbab90.svg";
export { ForwardRef as ReactComponent };